<template lang="pug">
.b-popup(:style="{ 'z-index': zIndex }")
  ._overlay()
  ._container(@click="close")
    ._spacer(@click.stop)
      ._wrap.wrap(:class="{ noPadding }")
        button._close(@click="close")
        ._content
          slot
</template>

<script>
import scrollLock from '@/utils/scrollLock';

/**
 * Окно попапа: оверлей, белая подложка и слот с содержимым.
 * Полноэкранный просмотр изображений, видео и PDF — это BasePreview,
 * открывается через popupModel.addPreview().
 */
export default {
  name: 'BasePopup',
  props: {
    zIndex: {
      type: Number,
      default: 10000,
    },
    noPadding: Boolean,
  },
  mounted() {
    // не пишем в body.style напрямую: попап открывается и поверх другого
    // попапа, и поверх боковой шторки — разблокировать страницу должен только
    // последний закрывшийся (см. utils/scrollLock)
    scrollLock.lock();
  },
  beforeDestroy() {
    scrollLock.unlock();
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: 10000;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.7);
  }

  &__container {
    z-index: 100000;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    cursor: pointer;
  }

  &__spacer {
    margin: auto;
    cursor: default;
  }

  &__wrap {
    position: relative;
    padding: 32px;
    background: var(--color-white);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin: 40px 0;
    box-sizing: border-box;
    max-width: calc(100vw - 32px);

    &.noPadding {
      padding: 0;
    }
  }

  &__close {
    position: absolute;
    width: 48px;
    height: 48px;
    background: #EBEFF2;
    top: -24px;
    right: -24px;
    cursor: pointer;
    border-radius: 100%;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      width: 1px;
      height: 20px;
      background: #C4C4C4;
      top:14px;
      left: 23px;
    }

    &:after { transform: rotate(-45deg); }
    &:before { transform: rotate(45deg); }
  }
}
</style>
